import React, { useContext, useEffect, useState } from "react";
import PERFORMANCE from "../../../../Assets/Images/PERFORMANCE.png";
import STRATEGIC from "../../../../Assets/Images/STRATEGIC.png";
import VISIONARY from "../../../../Assets/Images/VISIONARY.png";
import COLLABORATIVE from "../../../../Assets/Images/COLLABORATIVE.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import { initialDataLeaderShip } from "../groupReport-pdf/QuadrantInFocus";
import GroupReportContext from "../../../../Context/GroupReportContext";
import { useGroupReportDate } from '../../../../Context/GroupReportDate';
import { logItemsOverviewData } from '../../../../utils/itemsOverviewLogger';

const leadershipData = [
  {
    no: 9, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] believes stories help communicate the core values of an organization.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 10, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] wants to build an emotionally intelligent organization.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 11, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] believes leading an organization requires a unified set of operating principles.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 12, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] is motivated by organizations that prioritize measurable results.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 13, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name]'s most important responsibility is the long-term stewardship of organizational assets.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 14, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] is always looking to place a particular project within the context of the larger purpose.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 15, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] believes relationships of trust are essential to creating a successful organization.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 16, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] likes the challenge of working in a high-performance leadership team.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 17, score: 1,
    quadrant: "PERFORMANCE",
    question: "[First Name] believes great execution is primary.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 18, score: 3,
    quadrant: "VISIONARY",
    question: "[First Name] believes sharing inspirational stories should be an important part of our culture.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 19, score: 2,
    quadrant: "STRATEGIC",
    question: "[First Name] believes effective strategy is primary.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
  {
    no: 20, score: 4,
    quadrant: "COLLABORATIVE",
    question: "[First Name] believes developing a healthy culture is a very high value of their leadership.",
    s: 3, m1: 3, d1: 3, p1: 3, p2: 3, o1: 3, a: 3,
  },
];


const sideLabels = [
  {
    "label": "GUIDING VALUES",
    "bg": "#394554"
  },
  {
    "label": "COMMITMENTS",
    "bg": "#666666"
  },
  {
    "label": "BELIEFS",
    "bg": "#394554"
  },
  {
    "label": "MOTIVATIONS",
    "bg": "#666666"
  },
  {
    "label": "DRIVERS",
    "bg": "#394554"
  },
  {
    "label": "COACHING",
    "bg": "#666666"
  },
  {
    "label": "INFLUENCE",
    "bg": "#394554"
  },
  {
    "label": "DIRECTION",
    "bg": "#666666"
  }
]

const Logo = (quadrant) => {
  switch (quadrant) {
    case 'PERFORMANCE':
      return <img style={{ width: "14px" }} src={PERFORMANCE} alt="PERFORMANCE" className="logo" />;
    case 'STRATEGIC':
      return <img style={{ width: "14px" }} src={STRATEGIC} alt="STRATEGIC" className="logo" />;
    case 'VISIONARY':
      return <img style={{ width: "14px" }} src={VISIONARY} alt="VISIONARY" className="logo" />;
    case 'COLLABORATIVE':
      return <img style={{ width: "14px" }} src={COLLABORATIVE} alt="COLLABORATIVE" className="logo" />;
    default:
      return null;
  }
};

const LeadershipSecondItemOverview360 = ({ apiData, reportType, pageNumber }) => {
  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);
  const groupReportCtx = useContext(GroupReportContext)
  const { updateTablevaluels2Page2 } = useGroupReportDate();
  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';

  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el?.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el.fullName);
  const displayData = dynamicData;

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }


  const allResults = [];
  displayData?.forEach((el, index) => {
    const res = groupReportCtx?.calculateQuestionScoreLeadership(quadrantScores?.[el.quadrant], allVariableSets, el.no, "360_overview", allAssessmentDesignation, allAssessmentHash, allAssessmentFullName);
    if (res?.averageScore !== null) {
      allResults.push(res);
    }
  })

  // Collect all scores and save to context (page2)
  useEffect(() => {
    if (allResults?.length > 0) {
      const scoresArray = [];

      // This component contains only page-2 items (9–20)
      const secondPageItems = dynamicData.slice(8, 20);

      secondPageItems.forEach((item, index) => {
        const selfScore = groupReportCtx?.getAverageScore("360 Assessment", allResults, index + 8);
        const managerScore = groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index + 8);
        const directReportScore = groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index + 8);
        const peerScore = groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index + 8);
        const otherScore = groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index + 8);
        const averageScore = groupReportCtx?.getObserverAverageScore(allResults, index + 8) ?? "-";

        // Create array with scores only: [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore]
        const itemScores = [selfScore, managerScore, directReportScore, peerScore, otherScore, averageScore];
        scoresArray.push(itemScores);
      });

      // Save to context in page2 format
      updateTablevaluels2Page2(scoresArray);
      logItemsOverviewData({
        pageName: "Leadership Flow 2",
        items: secondPageItems,
        allResults,
        getAverageScore: groupReportCtx.getAverageScore,
        startIndex: 8,
      });
    }
  }, [allResults, dynamicData, groupReportCtx,]);

  // console.log("dynamicData", dynamicData, allResults)

  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="page" style={{ paddingBottom: "0", height: "634px", boxSizing: "border-box", position: "relative" }}>
        <div className="content">
          <div className="table" style={{ position: "relative" }}>
            <div className="tableRow tableHeader" style={{ background: "#245775", color: "#fff", display: "flex", zIndex: "1", position: "relative" }}>
              <div className="cellIndex" style={{ marginLeft: "40px", display: "flex", alignItems: "center" }}>#</div>
              <div className="cellQuadrant" style={{ fontSize: "9px", width: "15%", padding: "5.5px 0px 5.5px 13px", lineHeight: "13px" }}>Quadrant</div>
              <div className="cellLogo" ></div>
              <div className="cellQuestion" style={{paddingLeft: "9px" }}>Question</div>
              <div className="cellScore">S</div>
              <div className="cellScore">M</div>
              <div className="cellScore">D</div>
              <div className="cellScore">P</div>
              <div className="cellScore">O</div>
              <div className="cellScore">A</div>
            </div>
            {dynamicData.slice(0, 12).map((item, index) => {
              const selfScore = Number(groupReportCtx?.getAverageScore("360 Assessment", allResults, index + 8));
              const managerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Manager", allResults, index + 8));
              const directReportScore = Number(groupReportCtx?.getAverageScore("360 Assessment Direct Report", allResults, index + 8));
              const peerScore = Number(groupReportCtx?.getAverageScore("360 Assessment Peer", allResults, index + 8));
              const otherScore = Number(groupReportCtx?.getAverageScore("360 Assessment Other", allResults, index + 8));
              const averageScore = Number(groupReportCtx?.getObserverAverageScore(allResults, index + 8));
              const getLabelByIndex = (idx) => {
                if (idx === 0) {
                  return sideLabels[0].label;
                }
                return sideLabels[Math.floor(idx / 4)]?.label;
              };
              const getStyleByIndex = (idx) => {
                if (idx === 0) {
                  return { top: "19px", height: "33%", backgroundColor: sideLabels[0].bg };
                }
                if (idx === 4) {
                  return { top: "35.99%", height: "32%", backgroundColor: sideLabels[Math.floor(idx / 4)]?.bg };
                }
                return { top: "67.95%", height: "32%", backgroundColor: sideLabels[Math.floor(idx / 4)]?.bg };
              };

              return <div key={index} style={{ display: "flex", alignItems: "center", padding: "5px 0", }} className={`tableRow ${index % 2 === 0 ? 'evenRow' : 'oddRow'}`}>
                <div className='cellIndex'></div>
                {index === 0 || index % 4 === 0 ? (
                  <div className="sidelables" style={getStyleByIndex(index)}>
                    {getLabelByIndex(index)}
                  </div>
                ) : null}
                <div className="cellIndex" style={{ marginLeft: "30px" }}>{index + 9}.</div>
                <div className="cellQuadrant" style={{ width: "75px", marginLeft: "11px" }}>{leadershipData[index].quadrant}</div>
                <div className="cellLogo">{Logo(leadershipData[index].quadrant)}</div>
                <div className="cellQuestion">{leadershipData[index].question.replace(/\[First Name\]/g, respondentName)}</div>
                <div className="cellScore-parent" style={{ display: "flex", alignItems: "center", marginLeft: "" }}>
                  <div className="cellScore">{Number.isNaN(selfScore) ? "-" : selfScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(managerScore) ? "-" : managerScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(directReportScore) ? "-" : directReportScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(peerScore) ? "-" : peerScore.toFixed(1)}</div>
                  <div className="cellScore">{Number.isNaN(otherScore) ? "-" : otherScore.toFixed(1)}</div>
                  <div className="cellScore">{averageScore === 0 || Number.isNaN(averageScore) ? "-" : averageScore.toFixed(1)}</div>
                </div>
              </div>
            })}
          </div>
        </div>
        <div className='details-footer' style={{ background: "#EAF1F5", fontSize: "10px", margin: "0", padding: "4px 10px", marginTop: "auto", marginBottom: "4px" }}>
          <ul className='details-list'>
            <li>S - Self</li>
            <li>M - Manager</li>
            <li>D - Direct Report</li>
            <li>P - Peer</li>
            <li>O - Other</li>
            <li>A - Average</li>
          </ul>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default LeadershipSecondItemOverview360;
